import Swiper from "swiper";
import { enableOnlyTable } from ".";

const state = {
  components: []
}

const cacheState = () => {
  const sections = Array.from(document.querySelectorAll('[data-section="hub-cards-slider"]'));

  state.components = sections.reduce((components, section) => {
    const componentData = {
      id: section.dataset.overlayId,
      slider: section.querySelector('.hub-cards--wrapper'),
    }

    return [...components, componentData]
  }, [])
}

const addEventListeners = () => {
  document.addEventListener('overlay:open', updateSwiperOnShow)
}

const initSwiper = () => {
  state.components.forEach(component => {
    component.swiper = new Swiper(component.slider, {
      slidesPerView: 1.8,
      loopAdditionalSlides: 100,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
        769: {
          slidesPerView: 4
        },
        450: {
          slidesPerView: 2.5
        }
      },
      on: {
        resize: enableOnlyTable,
        afterInit: enableOnlyTable,
      }
    })
  })
}

function updateSwiperOnShow(e) {
  const componentsToUpdate = state.components.filter(component => component.id === e.detail.id);

  componentsToUpdate.forEach(component => {
    component.swiper.update();
  })
}

const init = () => {
  cacheState();
  initSwiper();
  addEventListeners();
}

export default init;